import type { MantineColor } from '@mantine/core';

const ZONE_MANTINE_COLORS: MantineColor[] = [
    'blue',
    'cyan',
    'teal',
    'green',
    'grape',
    'violet',
    'indigo',
    'orange',
    'pink',
    'lime',
];

const ZONE_COLOR_COUNT = ZONE_MANTINE_COLORS.length;

function hashZoneName(zoneName: string): number {
    const normalized = zoneName.trim().toLowerCase();
    let hash = 0;
    for (let i = 0; i < normalized.length; i += 1) {
        hash = (hash + normalized.charCodeAt(i) * (i + 1)) % ZONE_COLOR_COUNT;
    }
    return hash;
}

export function getAdvertisingZoneMantineColor(
    zoneName: string | null | undefined,
): MantineColor {
    if (!zoneName?.trim()) {
        return 'gray';
    }
    return ZONE_MANTINE_COLORS[hashZoneName(zoneName)] ?? 'gray';
}

export function getAdvertisingZoneShortLabel(
    zoneName: string | null | undefined,
): string {
    if (!zoneName?.trim()) {
        return '—';
    }
    return zoneName.trim().replace(/^zone\s+/i, '');
}
